export default {
  scope: {
    label: '业务主体:',
    tip: '腾讯内部业务：所申请授权用于腾讯公司自研产品，产品所有权归腾讯所有，如QQ、王者荣耀、微信开放平台等',
    content: '腾讯外部业务：所申请授权用于腾讯外部合作公司、腾讯客户的产品或项目'
  },
  applytype: {
    label: '申请类型:',
    tip: '测试：用于体验、试用、开发集成优图技术，不得用于商业用途，授权时间、设备数量有限制',
    content: '正式：用于上线发布、正式商用，必须提供合同，授权时间、设备数量按照合同约定执行'
  },
  contract: {
    label: '* 合作备案:',
    tip: '请上传合作备案邮件的截图、品牌合作的设计页面等素材'
  },
  bindtype: {
    label: '授权方式:',
    tip: '绑定APP：用于移动端应用，并最终以上架app store的形式来发布。如直播或短视频应用、游戏等。Bundle ID和Package Name是iOS、安卓app的唯一标识，请务必填写准确，如不确定请和贵司开发人员确认',
    content: '绑定设备：用于各类硬件设备、服务器等，如人脸识别门禁、Linux服务器等'
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/data/TipConstant.js